import React, { useState, useRef, useEffect } from 'react';
// import '../Preview.css'; // Import the CSS file
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import html2pdf from "html2pdf.js";
import Big from 'big.js';
const Invoice = ({nextInvoice = false, invoiceData={}}) => {
    const printRef = useRef();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [PRAMS, setParams] = useState({
        autoDownload: queryParams.get('autoDownload') || 'Y',
        storeName: queryParams.get('store_name') || invoiceData.store || 'N/A',
        userName: queryParams.get('user_name') || invoiceData.users_name || 'N/A',
        area: queryParams.get('area') || invoiceData.area || 'N/A',
        bind_person_name: queryParams.get('bind_person_name') || invoiceData.bind_person_name || 'N/A',
        bind_person_mobile: queryParams.get('bind_person_mobile') || invoiceData.bind_person_mobile || 'N/A',
        mobile: queryParams.get('mobile') || invoiceData.users_mobile || 'N/A',
        invoice_date: queryParams.get('invoice_date') || invoiceData.invoice_date || new Date(),
        invoice_no: queryParams.get('invoice_no') || invoiceData.invoice_no || 'N/A',
        pos_number: queryParams.get('pos_number') || invoiceData.pos_number || 'N/A',
        payment_mode: queryParams.get('payment_mode') || invoiceData.payment_mode || 'N/A',
        totalSales: parseFloat(queryParams.get('totalSales') || invoiceData.total_sales || 0),
        totalCommission: parseFloat(queryParams.get('totalCommission') || invoiceData.total_commission || 0),
        paidAmount: parseFloat(queryParams.get('paidAmount') || invoiceData.total_paid || 0),
        totalDue: parseFloat(queryParams.get('totalDue') || invoiceData.total_due || 0),
        subTotalDue: parseFloat(queryParams.get('subTotalDue') || invoiceData.sub_total_due || 0),
        old_balance: parseFloat(queryParams.get('old_balance') || invoiceData.old_pending_balance || 0),
        other_charges: parseFloat(queryParams.get('other_charges') || invoiceData.other_charges || 0),
        incentives: parseFloat(queryParams.get('incentives') || invoiceData.incentives || 0),
        start_date: queryParams.get('start_date') || invoiceData.start_date || '',
        start_time: queryParams.get('start_time') || invoiceData.start_time || '',
        end_date: queryParams.get('end_date') || invoiceData.end_date || '',
        end_time: queryParams.get('end_time') || invoiceData.end_time || '',

        lottoTotalSales : parseFloat(queryParams.get('lottoTotalSales') || invoiceData?.lottoTotalSales || 0),
        lottoTotalCommission : parseFloat(queryParams.get('lottoTotalCommission') || invoiceData?.lottoTotalCommission || 0),
        lottoPaidAmount : parseFloat(queryParams.get('lottoPaidAmount') || invoiceData?.lottoPaidAmount || 0),
        lottoIncentives : parseFloat(queryParams.get('lottoIncentives') || invoiceData?.lottoIncentives || 0),

        voucherTotalSales : parseFloat(queryParams.get('voucherTotalSales') || invoiceData?.voucherTotalSales || 0),
        voucherTotalCommission : parseFloat(queryParams.get('voucherTotalCommission') || invoiceData?.voucherTotalCommission || 0),
        voucherPaidAmount : parseFloat(queryParams.get('voucherPaidAmount') || invoiceData?.voucherPaidAmount || 0),
        voucherIncentives : parseFloat(queryParams.get('voucherIncentives') || invoiceData?.voucherIncentives || 0),

        e_commTotalSales : parseFloat(queryParams.get('e_commTotalSales') || invoiceData?.e_commTotalSales || 0),
        e_commTotalCommission : parseFloat(queryParams.get('e_commTotalCommission') || invoiceData?.e_commTotalCommission || 0),
        e_commPaidAmount : parseFloat(queryParams.get('e_commPaidAmount') || invoiceData?.e_commPaidAmount || 0),
        e_commIncentives : parseFloat(queryParams.get('e_commIncentives') || invoiceData?.e_commIncentives || 0),

        rtpTotalSales : parseFloat(queryParams.get('rtpTotalSales') || invoiceData?.rtpTotalSales || 0),
        rtpTotalCommission : parseFloat(queryParams.get('rtpTotalCommission') || invoiceData?.rtpTotalCommission || 0),
        rtpPaidAmount : parseFloat(queryParams.get('rtpPaidAmount') || invoiceData?.rtpPaidAmount || 0),
        rtpIncentives : parseFloat(queryParams.get('rtpIncentives') || invoiceData?.rtpIncentives || 0),
       
    });
    
    const generatePdf = async () => {
        try {
            if(invoiceData?.autoDownload === 'Y' || queryParams.get('autoDownload') === 'Y'){
                const element = printRef.current;
                const options = {
                    margin      : .25,
                    filename    : `${invoiceData?.pos_number?invoiceData?.pos_number:PRAMS.pos_number} Invoice - ${moment(new Date()).format('DD-MM-YYYY')}.pdf`,
                    image       : { type: "jpeg", quality: 1 },
                    html2canvas : { dpi: 1200, letterRendering: true, scale: 3 },
                    jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
                };
                await html2pdf().from(element).set(options).save();
            }
        } finally {
            // if(autoClose === 'Y'){
            //     window.close();
            // }
        }
      };

      useEffect(()=>{
        const isDataReady = Object.values(invoiceData).length > 0;
        if (isDataReady) {
            setParams({
                autoDownload: queryParams.get('autoDownload') || invoiceData?.autoDownload || 'Y',
                storeName: invoiceData.store || 'N/A',
                userName:invoiceData.users_name || 'N/A',
                mobile:invoiceData.users_mobile || 'N/A',
                area:invoiceData.area || 'N/A',
                bind_person_name:invoiceData.bind_person_name || 'N/A',
                invoice_date: invoiceData.invoice_date || new Date(),
                invoice_no: invoiceData.invoice_no || 'N/A',
                pos_number: invoiceData.pos_number || 'N/A',
                payment_mode: invoiceData.payment_mode || 'N/A',
                totalSales: parseFloat(invoiceData.total_sales || 0),
                totalCommission: parseFloat(invoiceData.total_commission || 0),
                paidAmount: parseFloat(invoiceData.total_paid || 0),
                totalDue: parseFloat(invoiceData.total_due || 0),
                subTotalDue: parseFloat(invoiceData.sub_total_due || 0),
                old_balance: parseFloat(invoiceData.old_pending_balance || 0),
                other_charges: parseFloat(invoiceData.other_charges || 0),
                incentives: parseFloat(invoiceData.incentives || 0),
                start_date: invoiceData.start_date || '',
                start_time: invoiceData.start_time || '',
                end_date: invoiceData.end_date || '',
                end_time: invoiceData.end_time || '',

                lottoTotalSales : parseFloat(invoiceData?.lottoTotalSales || 0),
                lottoTotalCommission : parseFloat(invoiceData?.lottoTotalCommission || 0),
                lottoPaidAmount : parseFloat(invoiceData?.lottoPaidAmount || 0),
                lottoIncentives : parseFloat(invoiceData?.lottoIncentives || 0),

                voucherTotalSales : parseFloat(invoiceData?.voucherTotalSales || 0),
                voucherTotalCommission : parseFloat(invoiceData?.voucherTotalCommission || 0),
                voucherPaidAmount : parseFloat(invoiceData?.voucherPaidAmount || 0),
                voucherIncentives : parseFloat(invoiceData?.voucherIncentives || 0),

                e_commTotalSales : parseFloat(invoiceData?.e_commTotalSales || 0),
                e_commTotalCommission : parseFloat(invoiceData?.e_commTotalCommission || 0),
                e_commPaidAmount : parseFloat(invoiceData?.e_commPaidAmount || 0),
                e_commIncentives : parseFloat(invoiceData?.e_commIncentives || 0),

                rtpTotalSales : parseFloat(invoiceData?.rtpTotalSales || 0),
                rtpTotalCommission : parseFloat(invoiceData?.rtpTotalCommission || 0),
                rtpPaidAmount : parseFloat(invoiceData?.rtpPaidAmount || 0),
                rtpIncentives : parseFloat(invoiceData?.rtpIncentives || 0),
            });
            // generatePdf();
        }else{
        }
        generatePdf();
      },[nextInvoice]);
  const b = (n) => new Big(n || 0);

  const showRtpColumn = [
    PRAMS.rtpTotalSales,
    PRAMS.rtpTotalCommission,
    PRAMS.rtpPaidAmount,
    PRAMS.rtpIncentives,
  ].some((value) => !b(value).eq(0));

  const footerLabelColSpan = showRtpColumn ? 10 : 8;

  const lottoNet   = b(PRAMS.lottoTotalSales).minus(b(PRAMS.lottoTotalCommission).plus(b(PRAMS.lottoPaidAmount)).plus(b(PRAMS.lottoIncentives)));
  const voucherNet = b(PRAMS.voucherTotalSales).minus(b(PRAMS.voucherTotalCommission).plus(b(PRAMS.voucherPaidAmount)).plus(b(PRAMS.voucherIncentives)));
  const eCommNet   = b(PRAMS.e_commTotalSales).minus(b(PRAMS.e_commTotalCommission).plus(b(PRAMS.e_commPaidAmount)).plus(b(PRAMS.e_commIncentives)));
  const rtpNet     = b(PRAMS.rtpTotalSales).minus(b(PRAMS.rtpTotalCommission).plus(b(PRAMS.rtpPaidAmount)).plus(b(PRAMS.rtpIncentives)));
  const totalNet   = b(PRAMS.totalSales).minus(b(PRAMS.totalCommission)).minus(b(PRAMS.paidAmount)).minus(b(PRAMS.incentives));
  const totalDueCalc = b(PRAMS.totalSales).plus(b(PRAMS.old_balance)).plus(b(PRAMS.other_charges)).minus(b(PRAMS.totalCommission)).minus(b(PRAMS.paidAmount)).minus(b(PRAMS.incentives));

  return (
  <>
    <div className="invoice-container" id="invoice" ref={printRef} style={{
        maxWidth: '800px',
        margin: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        fontSize: '13px',
      }}>
        <div className="logo-image" style={{display: 'flex',justifyContent: 'center'}}>
            {/* <img
            src='/logo.png'
            alt="Logo"
            style={{width: "10%"}}
            /> */}
        </div>
        <h4 className="invoice-title" style={{textAlign: 'center',marginBottom: '6px'}}>STATEMENT OF ACCOUNT</h4>
        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '5px'}}>
            <tbody>
                <tr>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left',}}>Invoice To</th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left',}}>Invoice No.</th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left',}}>Dated</th>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}><b>{PRAMS?.storeName || ''}</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{PRAMS.invoice_no || 'N/A'}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{moment(PRAMS?.invoice_date).format("DD-MM-YYYY")}</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Sales person's name</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Machine Ref.</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Mode/Terms of Payment</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{PRAMS?.bind_person_name || ''}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}><b>{PRAMS?.pos_number || 'N/A'}</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{PRAMS?.payment_mode || 'N/A'}</td>
                </tr>

                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Customer's Details</td>
                    <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Duration</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}><b>{`${PRAMS?.userName} | ${PRAMS?.mobile} | ${PRAMS?.area}` || ''}</b></td>
                    <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                        {/* {PRAMS?.start_date} */}
                        {`${moment(PRAMS?.start_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${PRAMS?.start_time}`).format(" hh:mm A")}`} to {`${moment(PRAMS?.end_date).format("DD-MM-YYYY")} ${moment(`2025-03-03 ${PRAMS?.end_time}`).format(" hh:mm A")}`}
                        </td>
                </tr>

            </tbody>
        </table>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '10px'}}>
            <tbody>
                <tr>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left',}}>Description</th>
                    {showRtpColumn && (
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'center',}}>Instat</th>
                    )}
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'center',}}>Daily Draw</th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'center',}}>Vouchers</th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'center',}}>E-Comm.</th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'center',}}>Total</th>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}> Total Sale </td>
                    {showRtpColumn && (
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {b(PRAMS.rtpTotalSales).toFixed(2)} </td>
                    )}
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {b(PRAMS.lottoTotalSales).toFixed(2)} </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {b(PRAMS.voucherTotalSales).toFixed(2)} </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {b(PRAMS.e_commTotalSales).toFixed(2)} </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> {b(PRAMS.totalSales).toFixed(2)} </td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>Less: Commission</td>
                    {showRtpColumn && (
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.rtpTotalCommission).toFixed(2)}</td>
                    )}
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.lottoTotalCommission).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.voucherTotalCommission).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.e_commTotalCommission).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.totalCommission).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>Less: Amount paid for voucher redeem directly by agent</td>
                    {showRtpColumn && (
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.rtpPaidAmount).toFixed(2)}</td>
                    )}
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.lottoPaidAmount).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.voucherPaidAmount).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.e_commPaidAmount).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.paidAmount).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>Less: Other incentives</td>
                    {showRtpColumn && (
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.rtpIncentives).toFixed(2)}</td>
                    )}
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.lottoIncentives).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.voucherIncentives).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.e_commIncentives).toFixed(2)}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.incentives).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}><strong>Net amount</strong></td>
                    {showRtpColumn && (
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}><b>{rtpNet.toFixed(2)}</b></td>
                    )}
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}><b>{lottoNet.toFixed(2)}</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}><b>{voucherNet.toFixed(2)}</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}><b>{eCommNet.toFixed(2)}</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}><b>{totalNet.toFixed(2)}</b></td>
                </tr>
                <tr>
                    <td colSpan={footerLabelColSpan} className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>Old balance pending</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.old_balance).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colSpan={footerLabelColSpan} className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>Other charges (if any)</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>{b(PRAMS.other_charges).toFixed(2)}</td>
                </tr>
                <tr>
                    <td colSpan={footerLabelColSpan} className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}><strong>Total due as per statement</strong></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}>
                        <b>{totalDueCalc.toFixed(2)}</b>
                    </td>
                </tr>
            </tbody>
        </table>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '5px'}}>
            <tbody>
                <tr>
                    <th colSpan="8" className="text-center" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left',}}>To be filled by Crown King representative</th>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong> Date of collection </strong>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong>Cash received</strong>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong>No. of tickets redeemed</strong>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong>Total value of redeem tickets</strong>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>
                </tr>
                <tr>
                    <td colSpan="4" className="text-center" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong>Balance due</strong>
                    </td>
                    <td colSpan="4" className="text-center" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    <strong>Due date</strong>
                    </td>
                </tr>
                <tr>
                    <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>
                    <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>
                    </td>

                </tr>
            </tbody>
        </table>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '5px'}}>
            <thead>
                <tr>
                <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Crown King accounts dept</th>
                <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Crown King sales executive</th>
                <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Agent name: Tel</th>
                <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2',textAlign: 'left'}}>Agent signature</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                <td colSpan="2" style={{ border: '1px solid #ddd',padding: '8px', textAlign: 'left', height: '50px' }} className="text-left"></td>
                <td colSpan="2" style={{ border: '1px solid #ddd',padding: '8px', textAlign: 'left', height: '50px' }} className="text-left"></td>
                <td colSpan="2" style={{ border: '1px solid #ddd',padding: '8px', textAlign: 'left', height: '50px' }} className="text-left"></td>
                <td colSpan="2" style={{ border: '1px solid #ddd',padding: '8px', textAlign: 'left', height: '50px' }} className="text-left"></td>
                </tr>
            </tbody>
        </table>

        {/* Additional tables with similar structure */}
        <div className="footer" style={{ marginTop: '20px',textAlign: 'center', marginBottom:'-10px' }}>
            <strong>Thank You</strong>
            {/*<p> The Meydan Hotel, Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, UAE </p> */}
        </div>
    </div>
  </>);
};

export default Invoice;